
import useFindReplace from "../../../../hooks/useFindReplace";
import TextAreaWithHighlight from "./TextAreaWithHighlight";
import { TranscriptionBlockType } from "../../../../utils/type";
import "./FindReplaceTextAreas.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { createNewSegment, updateBlock } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { Button } from "antd";
import React from "react";
import MdxEditorComponent from "../MdxEditorComponent/MdxEditorComponent";
interface FindReplaceTextAreasProps {
  texts: TranscriptionBlockType[];
  speakers: string[];
  disabled: boolean;
  type: string;
  packId: number;
  editorRef: React.MutableRefObject<any>;
}
const FindReplaceTextAreas = (props: FindReplaceTextAreasProps) => {
  const idTranscription = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].idTranscription);
  const { updateTranscriptText, allMatches, currentMatchIndex } = useFindReplace(props.texts, props.type, props.editorRef);
  const endTime = useSelector((state: RootState) => state.qCDetailPageState.endTime);
  const speakers = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].speakers);
  const createNewSegmentLoading = useSelector((state: RootState) => state.qCDetailPageState.createNewSegmentLoading);
  const dispatch = useAppDispatch();
  const handleCreateNewSegment = () => {
    //code here
    const payload = {
      TranscriptionId: idTranscription,
      NewBlocks: [
        {
          StartTimeSec: endTime + 1,
          EndTimeSec: endTime + 1,
          Speaker: speakers[0],
          Text: "",
        },
      ],
      UpdateBlocks: [],
    };
    dispatch(createNewSegment({ id: idTranscription, data: payload }));
  };
  return (
    <>
      {props.type === "Transcription" ? (
        <div className="find-replace-text-areas">
          {props.texts.map((text, index) => (
            <TextAreaWithHighlight
              key={index}
              transcript={text}
              index={index}
              disabled={props.disabled}
              texts={props.texts}
              updateTranscriptText={updateTranscriptText}
              allMatches={allMatches}
              currentMatchIndex={currentMatchIndex}
            />
          ))}
          <Button
            className="create-btn mb-4"
            loading={createNewSegmentLoading}
            onClick={() => handleCreateNewSegment()}>
            + Create New Segment
          </Button>
        </div>
      ) : (
        <div className="d-flex flex-column gap-3 overflow-hidden h-100">
          <MdxEditorComponent
            editorRef={props.editorRef}
            allMatches={allMatches}
            texts={props.texts}
            packId={props.packId}
            currentMatchIndex={currentMatchIndex}
            disabled={props.disabled}
            markdown={props.texts[0] ? props.texts[0].transcript : ""}
          />
          {/* <button
            className="button"
            disabled={props.disabled}
            onClick={() => {
              if (props.editorRef) {
                const newBlock = {
                  TranscriptionId: idTranscription,
                  TranscriptionBlocks: [
                    {
                      TranscriptionBlockId: props.texts[0].idTranscriptionBlock,
                      StartTimeSec: props.texts[0].startTimeSec,
                      EndTimeSec: props.texts[0].endTimeSec,
                      Speaker: props.texts[0].speaker,
                      Text: props.editorRef.current
                        .getMarkdown()
                        .replace(/<span class="highlighted">/g, "")
                        .replace(/<\/span>/g, ""),
                    },
                  ],
                };
                dispatch(
                  updateBlock({
                    id: props.packId,
                    data: newBlock,
                    blockIndex: 0,
                  })
                );
              } else {
                console.error("editorRef.current is undefined");
              }
            }}>
            Save
          </button> */}
        </div>
      )}
    </>
  );
};
export default FindReplaceTextAreas;
